import React from 'react';
import { withRouteData } from 'react-static';
//
import Logo from 'components/logo';
//
export default withRouteData(({ site }) => <Logo site={site} />);
